import { defineMessages } from 'react-intl';

import { So5LeaderboardGroupType } from '@sorare/core/src/__generated__/globalTypes';

export const Mode = {
  PRO: 'PRO',
  ARENA_CASH: 'ARENA_CASH',
  ARENA_ESSENCE: 'ARENA_ESSENCE',
} as const;

export type Mode = (typeof Mode)[keyof typeof Mode];

export const LineupMode = {
  ARCADE: 'ARCADE',
  PRO: 'PRO',
  ARENA: 'ARENA',
} as const;

export type LineupMode = (typeof LineupMode)[keyof typeof LineupMode];

export const modeColors: Record<Mode, string> = {
  [Mode.PRO]: 'var(--c-inventory-orange)',
  [Mode.ARENA_CASH]: 'var(--c-unique)',
  [Mode.ARENA_ESSENCE]: 'var(--c-arena-primary)',
};

export const modeMessages = defineMessages({
  [Mode.PRO]: { defaultMessage: 'Pro' },
  [Mode.ARENA_CASH]: { defaultMessage: 'Arena Cash' },
  [Mode.ARENA_ESSENCE]: { defaultMessage: 'Arena Essence' },
});

export const modeToArenaMode = (mode: Mode): 'cash' | 'essence' =>
  mode === Mode.ARENA_ESSENCE ? 'essence' : 'cash';

export const arenaModeToMode = (arenaMode: string): Mode =>
  arenaMode === 'essence' ? Mode.ARENA_ESSENCE : Mode.ARENA_CASH;

export const arenaModeToGroupType = (
  arenaMode: string
): So5LeaderboardGroupType =>
  arenaMode === 'cash'
    ? So5LeaderboardGroupType.ARENA_IN_SEASON
    : So5LeaderboardGroupType.ARENA_CLASSIC;
